<template>
	<Row class="flex-align-center">
		<FeatureIconsCard class="mr-3" :flowData="flowData" />
		<Col class="flex-justify-center">
			<Col class="workflow-title">
				<h3 class="one-row">{{ issue.error_message }}</h3>
				<h4>Issue in: {{ flowData.title }}</h4>
			</Col>
		</Col>
	</Row>
</template>
<script>
import FeatureIconsCard from '@/components/Modules/FeatureIconsCard.vue';
export default {
	name: 'IssueCardIconAndTexts',
	components: { FeatureIconsCard },
	props: {
		issue: { type: Object, required: true },
	},
	computed: {
		flowData() {
			return this.issue.flow_data;
		},
	},
};
</script>
<style scoped lang="scss">
.workflow-title {
	font-size: 15px;
	font-weight: normal;
	color: var(--primary-font-color);
	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; // num of rows to break
}
</style>
